module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut-haven-timber-hayman-0.729afd78.jpg";